import { SiteIdOverrideConfig } from "stores/wizard/config";
import { DayName } from "uitk-react-new-date-picker";

export const siteId70969: SiteIdOverrideConfig = {
  global: {
    heroImageSrc: "https://a.travel-assets.com/travel-assets-manager/cmct-2135/LATAM_Autumn_Argentina_1400x600.jpg",
  },
  hotel: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
    packageRatesTermsUrl: "/static/default/default/taap/contracts/hpr/BR.HPR.012021.pdf",
  },
  flight: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
  },
  package: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
  },
  car: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
    includeGT: false,
  },
  lx: {
    date: {
      firstDayOfWeek: DayName.SUN,
    },
  },
};
